// extracted by mini-css-extract-plugin
export var semicircle = "styles-module--semicircle--39f0a";
export var semicircle1 = "styles-module--semicircle1--e8320";
export var semicircle2 = "styles-module--semicircle2--f325f";
export var semicircle3 = "styles-module--semicircle3--8d663";
export var semicircle4 = "styles-module--semicircle4--ee370";